//noinspection ThisExpressionReferencesGlobalObjectJS
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['leaflet', 'jquery', 'map/mapConfigurationParser', 'map/tileLayerParser', 'map/poiConfigurationParser', 'map/popupMarkupCreator'], factory);
	} else {
		// Browser globals
		root.map = factory(root.L, root.jQuery, root.mapConfigurationParser, root.tileLayerParser, root.poiConfigurationParser, root.popupMarkupCreator);
	}
}(this, function (L, $, mapConfigurationParser, tileLayerParser, poiConfigurationParser, popupMarkupCreator) {
	"use strict";

	var INFO_LAYER_MARKUP = '<span class="close">X</span><div class="info-layer-content"></div>';
	var INFO_LAYER_CLOSE_SELECTOR = 'span.close';
	var FITBOUNDS_ZOOM = 15;
	// var ICON_FILE_DEFAULT = 'https://www.froebel-gruppe.de/typo3conf/ext/froebel_kita/Resources/Public/Img/marker.png';
	// var ICON_FILE_OFFICE = 'https://www.froebel-gruppe.de/typo3conf/ext/froebel_kita/Resources/Public/Img/marker_office.png';

	var ICON_FILE_DEFAULT = '/typo3conf/ext/integration_project/Resources/Public/_Default/Build/assets/images/pin_gruen.svg';
	var ICON_FILE_OFFICE = '/typo3conf/ext/integration_project/Resources/Public/_Default/Build/assets/images/pin_blau.svg';


	var markers = {
		default: L.icon({ iconUrl: ICON_FILE_DEFAULT, iconSize: [32, 32], popupAnchor: [0, -20] }),
		office: L.icon({ iconUrl: ICON_FILE_OFFICE, iconSize: [32, 32], popupAnchor: [0, -20] })
	};

	$('[data-is-map=true]').each(function () {
		var pois = [];
		var mapConfiguration = mapConfigurationParser(this);
		var tileLayerConfiguration = tileLayerParser(this);
		var fitBoundConfiguration = mapConfiguration.padding
			? { padding: [mapConfiguration.padding, mapConfiguration.padding] }
			: null;
		var map = L.map(this, mapConfiguration);
		var poiLayerGroup = L.featureGroup().addTo(map);
		var officeLayerGroup = L.featureGroup().addTo(map);
		L.tileLayer(tileLayerConfiguration.urlTemplate, tileLayerConfiguration.options).addTo(map);
		var mapWrap = $($(this).data('map-wrap'));
		var infoLayer = $($(this).data('map-info-layer'));
		map.mapWrap = mapWrap;
		map.infoLayer = infoLayer;
		infoLayer.html(INFO_LAYER_MARKUP);
		infoLayer.find(INFO_LAYER_CLOSE_SELECTOR).on('click', function () {
			map.closePopup();
		});
		$($(this).attr('data-poi-list')).find('[data-poi]').each(function () {
			var poiConfiguration = poiConfigurationParser(this);
			var poi = createPoi(this, poiConfiguration);
			var markerIcon;
			poi.element = this;
			poi.map = map;
			$(this).data('poi-object', poi);
			var popup = L.popup().setContent(createPopup(this, poi));
			popup.poi = poi;
			poi.bindPopup(popup);
			if (poiConfiguration.icon) {
				markerIcon = L.icon({ iconUrl: poiConfiguration.icon, iconSize: [32, 32], popupAnchor: [0, -20] });
			} else if (poiConfiguration.office) {
				markerIcon = markers.office;
			} else {
				markerIcon = markers.default;
			}
			poi.setIcon(markerIcon);
			if (poiConfiguration.office) {
				poi.addTo(officeLayerGroup);
			} else {
				pois.push(poi);
			}
		});

		// Call fitbounds event on map element when adding or removing marker to adopt zoom
		$(this).on('fitbounds.map', function (e, additionalConfiguration) {
			var count = poiLayerGroup.getLayers().length;
			if (!count) {
				return;
			}
			if (count == 1) {
				map.setView(poiLayerGroup.getLayers()[0].getLatLng(), FITBOUNDS_ZOOM);
				return;
			}
			map.fitBounds(poiLayerGroup.getBounds(), $.extend({}, fitBoundConfiguration, additionalConfiguration || {}));
		});
		$(this).on('update-list.map', function () {
			pois.forEach(function (poi) {
				if ($(poi.element).data('map-hidden') === true) {
					poiLayerGroup.removeLayer(poi);
				} else {
					poi.addTo(poiLayerGroup);
				}
			});
		});
		$(this).on('focus-poi.map', function (e, element) {
			var poi = $(element).data('poi-object');
			map.setView(poi.getLatLng(), FITBOUNDS_ZOOM);
			poi.openPopup();
		});
		$(this).trigger('update-list.map');
		$(this).trigger('fitbounds.map', { animate: false });
		var popupToOpenFirst = $($(this).attr('data-poi-list'))
			.filter('[data-map-activate-first]')
			.find('[data-poi]')[0];
		if (popupToOpenFirst) {
			$(this).trigger('focus-poi.map', popupToOpenFirst);
		}


		$('[data-marker-id]').on('click', function (event) {
			event.preventDefault(); // Prevent the default link action
			var id = $(this).data('marker-id'); // Assuming the headline is stored as a data attribute
			openMatchingMarker(id);
		});

		function openMatchingMarker(id) {
			// Update: Find matching POI based on data-poi-uid attribute of the h3 element inside the POI
			var matchingPoi = pois.find(poi => {
				console.log($(poi.element).find('h3').data('poi-id'), id);
				return $(poi.element).find('h3').data('poi-id') == id;
			});

			if (matchingPoi) {
				map.setView(matchingPoi.getLatLng(), FITBOUNDS_ZOOM); // Center the map on the marker
				matchingPoi.openPopup(); // Open the popup

				// Scroll the froebelMap-wrap element into view
				document.getElementById('froebelMap-wrap').scrollIntoView({
					behavior: 'smooth', // Smooth scroll
					block: 'center' // Scroll to the top of the element
				});
			}
		}
	});


	function createPoi(element, configuration) {
		if (configuration.type === "marker") {
			return createMarker(element, configuration);
		}
	}

	function createPopup(element, poi) {
		return popupMarkupCreator(element, poi);
	}

	//noinspection JSUnusedLocalSymbols
	function createMarker(element, configuration) {
		return L.marker(configuration.coordinates);
	}

}));
